import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import ServiceDetailPage from "../pages/services/detail/page";
import CommercialKitchenPage from "../pages/commercial-kitchen/page";
import HvacSystemsPage from "../pages/hvac-systems/page";
import HospitalPharmacyPage from "../pages/hospital-pharmacy/page";
import FoodProcessingPage from "../pages/food-processing/page";
import BlogPage from "../pages/blog/page";
import StorePage from "../pages/store/page";
import DesignServicesPage from "../pages/design-services/page";
import WeldingServicesPage from "../pages/welding-services/page";
import PlumbingServicesPage from "../pages/plumbing-services/page";
import StainlessRailingPage from "../pages/stainless-railing/page";
import CompanyProfilePage from "../pages/company-profile/page";
import ProjectGalleryPage from "../pages/project-gallery/page";
import TrackOrderPage from "../pages/store/track/page";
import CmsSections from "../components/cms/CmsSections";
import CmsPage from "../components/cms/CmsPage";

// `cms(slug, <Page/>)` lets the admin Web Editor override a page when a layout
// is published for that slug; otherwise the original page renders unchanged.
const cms = (slug: string, el: React.ReactNode) => <CmsSections slug={slug}>{el}</CmsSections>;

const routes: RouteObject[] = [
  { path: "/", element: cms("home", <Home />) },
  { path: "/about", element: cms("about", <AboutPage />) },
  { path: "/services", element: cms("services", <ServicesPage />) },
  { path: "/services/:slug", element: <ServiceDetailPage /> },
  { path: "/commercial-kitchen", element: cms("commercial-kitchen", <CommercialKitchenPage />) },
  { path: "/hvac-systems", element: cms("hvac-systems", <HvacSystemsPage />) },
  { path: "/hospital-pharmacy", element: cms("hospital-pharmacy", <HospitalPharmacyPage />) },
  { path: "/food-processing", element: cms("food-processing", <FoodProcessingPage />) },
  { path: "/design-services", element: cms("design-services", <DesignServicesPage />) },
  { path: "/welding-services", element: cms("welding-services", <WeldingServicesPage />) },
  { path: "/plumbing-services", element: cms("plumbing-services", <PlumbingServicesPage />) },
  { path: "/project-gallery", element: cms("project-gallery", <ProjectGalleryPage />) },
  { path: "/company-profile", element: cms("company-profile", <CompanyProfilePage />) },
  { path: "/stainless-railing", element: cms("stainless-railing", <StainlessRailingPage />) },
  // Data-driven pages keep their dynamic rendering (not CMS-overridable):
  { path: "/blog", element: <BlogPage /> },
  { path: "/store", element: <StorePage /> },
  { path: "/store/order", element: <TrackOrderPage /> },
  // Brand-new pages created in the Web Editor render here; unknown slugs -> 404:
  { path: "*", element: <CmsPage /> },
];

export default routes;
